import { POST, GET } from '@/utils/request'
import Api from './url'

export const getScoreList = async (params: object) => {
  return await GET({
    url: Api.getScoreList,
    params,
    showError: false
  })
}
